import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";
import {resetEntity, resetPage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {forgottenPassword} from "../actions/session";
import {showModal} from "../actions/modal";
import {loadParty} from '../actions/parties';
import {defaultState as entityDefaultState} from '../reducers/entity';
import PartyDetail from '../components/party/PartyDetail';
import {breadcrumbs, Grid, resolveApiResult, setPageTitle} from "../utils";
import {BaseStatus, PartyType} from "../utils/enums";
import {loadIntakes} from "../actions/intakes";
import {loadExits} from "../actions/exits";
import {defaultState} from "../reducers/paginate";

class PartyDetailPage extends Component {

	constructor(props) {
		super(props);

		this.handleTabSelect = this.handleTabSelect.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentWillMount() {
		this.handleFetchEnums(['dogAll', 'user']);
		this.loadParty(this.props.match.params.partyId);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.match.params.partyId !== this.props.match.params.partyId
			|| (nextProps.match.params.tab === 'detail' && this.props.match.params.tab !== 'detail')) {
			this.loadParty(nextProps.match.params.partyId);
		}
	}

	loadParty(partyId) {
		this.props.loadParty(partyId).then((json) => {
			if (resolveApiResult(json)) {
				this.props.loadIntakes({partyId, orderCol: "intakeAt", orderDir: "desc", statuses: [BaseStatus.ACTIVE]});
				this.props.loadExits({partyId, orderCol: "exitAt", orderDir: "desc", statuses: [BaseStatus.ACTIVE]});
			}
		});
	}

	componentWillUnmount() {
		setPageTitle();
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handleTabSelect(tab) {
		this.props.history.push('/vencitele/' + this.props.match.params.partyId + '/' + tab)
	}

	render() {
		const {match: {params}, entity, intakesPage, exitsPage, session, enums} = this.props;
		if (entity.isFetchingItem || entity.item === null) {
			return Grid.renderIsFetchingData()
		}
		const item = entity.item;

		const tab = params.tab || 'detail';

		const bc = [
			{url: '/vencitele', title: 'Osoby'},
			{
				url: '/vencitele/' + params.partyId, title: entity && item && item.partyId
					? (item.partyType === PartyType.PO ? item.companyName : (item.lastName + ' ' + item.firstName))
					: '...', literal: true
			}
		];
		if (tab !== 'detail') {
			bc.push({url: '/vencitele/' + params.partyId + '/' + tab, title: tab});
		}
		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<PartyDetail {...entity}
					intakesPage={intakesPage} exitsPage={exitsPage}
					enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onShowModal={this.props.showModal}/>
			</div>
		)
	}
}

PartyDetailPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadParty: PropTypes.func.isRequired,
	loadIntakes: PropTypes.func.isRequired,
	loadExits: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	resetEntity: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {parties},
		pagination: {intakes, exits},
		enums,
		session
	} = state;

	const entity = parties[ownProps.match.params.partyId] || entityDefaultState;

	const intakesPage = intakes[0] || defaultState;
	const exitsPage = exits[0] || defaultState;

	return {
		entity,
		intakesPage,
		exitsPage,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadParty,
	loadIntakes,
	loadExits,
	loadGeneralEnum,
	forgottenPassword,
	resetEntity,
	resetPage,
	showModal
})(PartyDetailPage)



// WEBPACK FOOTER //
// ./src/containers/PartyDetailPage.js